<template>
  <div id="app">
    <div class="iframe">
      <iframe
        ref="iframe"
        src="./mms3D/index1.html"
        frameborder="0"
        style="width: 100%; height: 100%"
        id="iframe"
      ></iframe>
    </div>
    <home-header></home-header>
    <transition name="bottom">
      <home-bottom
        v-show="this.$store.state.idbottom1"
        ref="bottom"
      ></home-bottom>
    </transition>
    <video1
      v-if="this.$store.state.video"
      :videoSrc="this.videoSrc"
      ref="child"
    ></video1>
    <router-view @uncheck="uncheck" />
  </div>
</template>

<script>
import homeHeader from "./components/homeHeader";
import homeBottom from "./components/homeBottom";
import video1 from "./views/service/components/video1";
export default {
  name: "App",
  data() {
    return {
      change: "",
      isshow: false,
      videoSrc: "",
      timer: "",
      count: 0, //计时器
      go: "", //用来存储方法
      isMove: false, //是否開啓迅游
    };
  },
  components: {
    homeHeader,
    homeBottom,
    // eslint-disable-next-line vue/no-unused-components
    video1,
  },
  mounted() {
    window.changeVideo = this.changeVideo;
    
    window.stop = this.stop;
    window.addEventListener("message", (e) => {
      if (e.data.type == "initialize") {
        this.actionListener();
      }
    });
  },
  methods: {
    changeVideo() {
      setTimeout(() => {
        this.$store.state.video = true;
      }, 300);
      window.addEventListener("message", (e) => {
        try {
          if (e.data.id.id != undefined) {
            this.$store.state.videoId = e.data.id.id;
            if (
              e.data.id.id == "nlc_xk_dc_bx" ||
              e.data.id.id == "nlc_xk_dc_nx" ||
              e.data.id.id == "nlc_xk_xc_bx" ||
              e.data.id.id == "nlc_xk_xc_nx" ||
              e.data.id.id == "nlc_xk_z_nx_bx"
            ) {
              this.$store.state.building = "n_L";
            } else if (
              e.data.id.id == "bc_b_dx" ||
              e.data.id.id == "bc_d_b_xx" ||
              e.data.id.id == "bc_d_n_xx" ||
              e.data.id.id == "bc_n_dx" ||
              e.data.id.id == "bc_x_dx" ||
              e.data.id.id == "nc_x_dx"
            ) {
              this.$store.state.building = "L";
            } else if (
              e.data.id.id == "3B314" ||
              e.data.id.id == "3B315" ||
              e.data.id.id == "3A410" ||
              e.data.id.id == "3A411" ||
              e.data.id.id == "3A412" ||
              e.data.id.id == "3B410" ||
              e.data.id.id == "3B412" ||
              e.data.id.id == "3B413" ||
              e.data.id.id == "3B414" ||
              e.data.id.id == "3A508" ||
              e.data.id.id == "3A509" ||
              e.data.id.id == "3B509" ||
              e.data.id.id == "3B507"
            ) {
              this.$store.state.building = "three";
            } else if (
              e.data.id.id == "5D201" ||
              e.data.id.id == "5D202" ||
              e.data.id.id == "5D302"
            ) {
              this.$store.state.building = "five";
            }
            if (e.data.id.id == "bc_d_b_xx") {
              this.$store.state.monitorNum = "2号";
            } else if (e.data.id.id == "bc_d_n_xx") {
              this.$store.state.monitorNum = "3号";
            } else if (e.data.id.id == "bc_x_dx") {
              this.$store.state.monitorNum = "5号";
            } else if (e.data.id.id == "nc_x_dx") {
              this.$store.state.monitorNum = "6号";
            } else if (e.data.id.id == "bc_n_dx") {
              this.$store.state.monitorNum = "4号";
            } else if (e.data.id.id == "nlc_xk_dc_bx") {
              this.$store.state.monitorNum = "7号";
            } else if (e.data.id.id == "nlc_xk_xc_bx") {
              this.$store.state.monitorNum = "9号";
            } else if (e.data.id.id == "nlc_xk_z_nx_bx") {
              this.$store.state.monitorNum = "11号";
            } else if (e.data.id.id == "nlc_xk_dc_nx") {
              this.$store.state.monitorNum = "8号";
            } else if (e.data.id.id == "nlc_xk_xc_nx") {
              this.$store.state.monitorNum = "10号";
            } else if (e.data.id.id == "bc_b_dx") {
              this.$store.state.monitorNum = "1号";
            } else {
              this.$store.state.monitorNum = e.data.id.id;
            }
            this.$store.commit("changevideo");
            this.videoSrc = this.$store.getters.getVideo;
            // this.$refs.child.getVideoSrc();
          }
          // eslint-disable-next-line no-empty
        } catch {}
      });
    },
    actionListener() {
      
      var outTime = 2; //分钟
      let that = this;
      this.go = function () {
        if (that.count == outTime * 60) {
          that.$store.state.show = false;
          that.$store.state.idbottom = false;
          that.$store.state.map = false;
          that.$store.state.video = false;
          that.$store.state.idbottom1 = false;
          that.isMove = true;
          document.getElementById("iframe").contentWindow.MMAPI.ineect();
          clearInterval(that.timer);
        }
        that.count++;
      };

      //页面倒计时
      clearInterval(this.timer);
      this.timer = window.setInterval(that.go, 1000);
    },
    //停止巡游
    stop() {
      let that = this;
      this.count = 0;
      if (that.isMove) {
        document.getElementById("iframe").contentWindow.MMAPI.cct();
        clearInterval(this.timer);
        this.timer = window.setInterval(that.go, 1000);
        this.$store.state.show = true;
        this.$store.state.idbottom = true;
        this.$store.state.idbottom1 = true;
      }

      that.isMove = false;
    },
    //取消底部选中的方法
    uncheck() {
      this.$refs.bottom.initialization();
    },
  },
};
</script>

<style>
.distributed-header {
  overflow: hidden;
  white-space: nowrap;
}
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  padding: 0;
  /* background: url("./assets/img/bg.png"); */
  background-size: 100% 100%;
}
.bottom-enter-active,
.bottom-leave-active {
  transition: all 0.6s;
}
.bottom-enter, .bottom-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-10%);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: pmzd;
  src: url("./assets/fonts/pmzd.TTF");
}
@font-face {
  font-family: SourceHanSansCN;
  src: url("./assets/fonts/SourceHanSansCN-Regular.ttf");
}
@font-face {
  font-family: Regular;
  src: url("./assets/fonts/Regular.ttf");
}
ul,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}
.iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
